import { z } from 'zod';

const signedCentsSchema = z.string().regex(/^-?\d+$/);

export const ServicePricingBodySchema = z.strictObject({
  pricingModel: z.enum(['FIXED', 'HOURLY']).nullable().optional(),
  costCents: signedCentsSchema.nullable().optional(),
  salePriceCents: signedCentsSchema.nullable().optional(),
  hourlyRateCents: signedCentsSchema.nullable().optional(),
  maxDiscountBp: z.number().int().nullable().optional(),
  currency: z.string().length(3).nullable().optional(),
});

export const ServicePricingResponseSchema = z.object({
  pricingModel: z.enum(['FIXED', 'HOURLY']).nullable(),
  costCents: z.string().nullable(),
  salePriceCents: z.string().nullable(),
  hourlyRateCents: z.string().nullable(),
  marginBp: z.number().int().nullable(),
  maxDiscountBp: z.number().int().nullable(),
  currency: z.string().nullable(),
});

export type ServicePricingBody = z.infer<typeof ServicePricingBodySchema>;
export type ServicePricingResponse = z.infer<typeof ServicePricingResponseSchema>;
